import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyBaIiYWJq96BEavrSz0ojamNtt4Lw_cQFw",
  authDomain: "vi-viet-nam-user.firebaseapp.com",
  projectId: "vi-viet-nam-user",
  storageBucket: "vi-viet-nam-user.firebasestorage.app",
  messagingSenderId: "148096568727",
  appId: "1:148096568727:web:2695155f96a8b27f1708d2",
  measurementId: "G-N1TBD2JZF0",
};

// recapcha
export const PROJECT_ID = "vi-viet-nam-user";
export const appUser = initializeApp(firebaseConfig, PROJECT_ID);
export const reCAPTCHA = "6Le7rRErAAAAAJHK9vaN4b1n3o1uuJwM2qyrKERs";
export const MEDIA_STORAGE =
  "https://storage.googleapis.com/" + firebaseConfig.storageBucket + "/";
